import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between h-16 px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="flex items-center gap-10">
          <Link
            to="/"
            className="flex items-center gap-2 no-underline"
          >
            <span
              className="text-2xl font-heading text-primary-500 whitespace-nowrap"
            >
              韩漫漫画
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <button
            type="button"
            className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-vip-crown-line mr-1.5"></i>
            免费阅读
          </button>
        </div>

        <button
          type="button"
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4 space-y-1">
          <Link to="/" className="block px-4 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-200 whitespace-nowrap">首页</Link>
          {categories.filter(c => c.slug !== 'all').map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="block px-4 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-200 whitespace-nowrap"
            >
              {cat.name}
            </Link>
          ))}
          <Link to="/about" className="block px-4 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-200 whitespace-nowrap">关于我们</Link>
          <button
            type="button"
            className="w-full mt-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-vip-crown-line mr-1.5"></i>
            免费阅读
          </button>
        </div>
      )}
    </header>
  );
}